package org.moxultimate.topwithmox.dashboard

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.moxultimate.topwithmox.components.texts.DescriptionText
import org.moxultimate.topwithmox.components.texts.DetailsText
import org.moxultimate.topwithmox.components.texts.TitleText
import org.moxultimate.topwithmox.components.texts.moxTextGradient
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.text.SpanText
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_BG_DESKTOP
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_BG_MOBILE
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_DESCRIPTION
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_DETAIL_DETAIL_1
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_DETAIL_DETAIL_2
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_DETAIL_DETAIL_3
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_DETAIL_TITLE_1
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_DETAIL_TITLE_2
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_DETAIL_TITLE_3
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_TITLE
import org.moxultimate.topwithmox.statics.DashboardStatics.FIRST_SECTION_VISION
import org.moxultimate.topwithmox.theme.FontFamily


@OptIn(DelicateApi::class)
@Composable
fun FirstSection() {
    val breakpoint = rememberBreakpoint()

    when (breakpoint) {
        Breakpoint.ZERO, Breakpoint.SM, Breakpoint.MD -> FirstSectionMobile()
        else -> FirstSectionDesktop()
    }
}


@Composable
private fun FirstSectionDesktop() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(clamp(min = 700.px, value = 88.vh, max = 1400.px))
            .styleModifier {
                property("background-image", "url('$FIRST_SECTION_BG_DESKTOP')")
                property("background-size", "cover")
                property("background-position", "center")
                property("background-repeat", "no-repeat")
            },
    ) {
        Column(
            modifier = Modifier
                .width(45.vw)
                .padding(top = clamp(min = 150.px, value = 25.vh, max = 400.px), left = 12.vw)
        ) {
            TitleText(
                FIRST_SECTION_TITLE,
                modifier = Modifier.moxTextGradient()
            )

            SpanText(
                text = FIRST_SECTION_VISION,
                modifier = Modifier
                    .padding(top = 16.px)
                    .fontFamily(FontFamily)
                    .fontSize(clamp(min = 14.px, value = 1.1.vw, max = 18.px))
                    .color(Colors.White)
                    .styleModifier { property("opacity", "0.85") }
                    .styleModifier { property("font-style", "italic") },
            )

            DescriptionText(
                modifier = Modifier.padding(top = 20.px),
                description = FIRST_SECTION_DESCRIPTION
            )

            Row(
                modifier = Modifier.padding(top = 32.px),
                horizontalArrangement = Arrangement.spacedBy(40.px)
            ) {
                DetailsText(
                    title = FIRST_SECTION_DETAIL_TITLE_1,
                    details = FIRST_SECTION_DETAIL_DETAIL_1
                )

                DetailsText(
                    title = FIRST_SECTION_DETAIL_TITLE_2,
                    details = FIRST_SECTION_DETAIL_DETAIL_2
                )

                DetailsText(
                    title = FIRST_SECTION_DETAIL_TITLE_3,
                    details = FIRST_SECTION_DETAIL_DETAIL_3
                )
            }
        }
    }
}


@Composable
private fun FirstSectionMobile() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(600.px)
            .styleModifier {
                property("background-image", "url('$FIRST_SECTION_BG_MOBILE')")
                property("background-size", "cover")
                property("background-position", "center")
                property("background-repeat", "no-repeat")
            },
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .width(90.vw)
                .padding(left = 10.vw, right = 10.vw)
                .margin(top = 160.px)
                .align(Alignment.TopCenter)
        ) {
            TitleText(
                FIRST_SECTION_TITLE,
                modifier = Modifier.moxTextGradient()
            )

            SpanText(
                text = FIRST_SECTION_VISION,
                modifier = Modifier
                    .padding(top = 14.px)
                    .fontFamily(FontFamily)
                    .fontSize(14.px)
                    .color(Colors.White)
                    .styleModifier { property("opacity", "0.85") }
                    .styleModifier { property("font-style", "italic") },
            )

            DescriptionText(
                modifier = Modifier.padding(top = 18.px),
                description = FIRST_SECTION_DESCRIPTION,
            )

            Row(
                modifier = Modifier.padding(top = 32.px),
                horizontalArrangement = Arrangement.spacedBy(30.px)
            ) {
                DetailsText(
                    title = FIRST_SECTION_DETAIL_TITLE_1,
                    details = FIRST_SECTION_DETAIL_DETAIL_1
                )

                DetailsText(
                    title = FIRST_SECTION_DETAIL_TITLE_2,
                    details = FIRST_SECTION_DETAIL_DETAIL_2
                )

                DetailsText(
                    title = FIRST_SECTION_DETAIL_TITLE_3,
                    details = FIRST_SECTION_DETAIL_DETAIL_3
                )
            }
        }
    }
}